export const formatSize = (size) => `${(size / (1024 * 1024)).toFixed(2)} MB`;

/**
 * Generates CSV content from headers and data
 * @param {Array} headers - Array of header strings
 * @param {Array} data - 2D array of data rows
 * @returns {string} CSV content as string
 */
export const generateCsvContent = (headers, data) => {
  return [headers.join(","), ...data.map((row) => row.join(","))].join("\n");
};

/**
 * Downloads content as a file
 * @param {string} content - Content to download
 * @param {string} filename - Name of the file
 * @param {string} type - MIME type (default: 'text/csv;charset=utf-8;')
 */
export const downloadFile = (
  content,
  filename,
  type = "text/csv;charset=utf-8;"
) => {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
